import { getApiHost } from '@hotjar/common';
import axios from 'axios';
import { setAxiosInterceptors } from './setAxiosInterceptors';

export const configureAxiosDefaults = (): void => {
  axios.defaults.withCredentials = true;
  axios.defaults.baseURL = getApiHost();

  setAxiosInterceptors(axios);
};
